import { gql } from '@apollo/client';
import client from './ApolloClient';

// Create Article Mutation
const CREATE_ARTICLE_MUTATION = gql`
  mutation CreateArticle($data: ArticleCreateInput!) {
    createArticle(data: $data) {
      id
      title
      url
      content
      views
      categoryId
      createdAt
      updatedAt
    }
  }
`;


export const FIND_UNIQUE_ARTICLE = gql`
  query FindUniqueArticle($id: Int!) {
    findUniqueArticle(where: { id: $id }) {
      id
      title
      content
      createdAt
      views
      tags
      visibility
      ArticleAttachment{
      id
      url
      label
      }
      authorId
      coverUrl
      categoryId
      subcategoryId
      likes {
        id
      }
    }
  }
`;

// Update Article Mutation
const UPDATE_ARTICLE_MUTATION = gql`
  mutation UpdateArticle($id: Int!, $data: ArticleUpdateInput!) {
    updateArticle(where: { id: $id }, data: $data) {
      id
      title
      url
      content
      views
      categoryId
      updatedAt
    }
  }
`;

// Delete Article Mutation
const DELETE_ARTICLE_MUTATION = gql`
  mutation DeleteArticle($id: Int!) {
    deleteArticle(where: { id: $id }) {
      id
    }
  }
`;

// Delete Article Mutation
const APPROVE_ARTICLE_MUTATION = gql`
  mutation updateArticleStatus($articleId: Float!,$status: String!) {
    updateArticleStatus(articleId: $articleId,status:$status ) {
     success
     message
     
    }
  }
`;


// GraphQL mutation for deleting a category
const DELETE_CATEGORY_MUTATION = gql`
  mutation deleteCategory($id: Int!) {
    deleteCategory(where: { id: $id }) {
      id
    }
  }
`;

// Fetch Articles Query
const GET_PUBLIC_ARTICLES_QUERY = gql`
  query {
    listPublicArticles(orderBy: { createdAt: desc }) {
      id
      title
      url
      content
      views
      categoryId
      createdAt
      updatedAt
      Category {
        name
        id
      }
      coverUrl
      visibility
      tags
      SubCategory {
        name
        id
      }
      authorId
      status
      subcategoryId
      likes {
        id
      }
    }
  }
`;


// Fetch Articles Query
const GET_ARTICLES_QUERY = gql`
  query  {
    listArticles {
      id
      title
      url
      content
      views
      categoryId
      subcategoryId
      createdAt
      updatedAt,
      Category{
      id
      name},
      visibility
      status
      tags
      authorId,
      SubCategory{
      id
      name},
      User{
      name}
     
      coverUrl
      likes{
      id}
    }
  }
`;

const GET_SITE_ARTICLES_QUERY = gql`
  query {
    listApprovedArticles(orderBy: { createdAt: desc }) {
      id
      title
      url
      content
      views
      categoryId
      subcategoryId
      createdAt
      updatedAt
      Category {
        name
      }
      visibility
      status
      tags
      authorId
      SubCategory {
        name
      }
      coverUrl
      likes {
        id
      }
    }
  }
`;




// Fetch Articles Query
const GET_EDITOR_ARTICLES_QUERY = gql`
  query  {
    listArticles {
      id
      title
      url
      content
      views
      categoryId
      createdAt
      updatedAt,
      Category{
      name},
      visibility
      tags
      SubCategory{
      name},
      ArticleImage{
      imageUrl},
      coverUrl
      subcategoryId
      likes{
      id}
    }
  }
`;

// Create Article Service
export const createArticleService = async (data) => {
  const token = localStorage.getItem('authToken');
  console.log(data);
  
  const response = await client.mutate({
    mutation: CREATE_ARTICLE_MUTATION,
    variables: { data },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.createArticle;
};

// Update Article Service
export const updateArticleService = async (id, data) => {
  const token = localStorage.getItem('authToken');
  const response = await client.mutate({
    mutation: UPDATE_ARTICLE_MUTATION,
    variables: { id:parseInt(id), data },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.updateArticle;
};

// Delete Article Service
export const deleteArticleService = async (id) => {
  const token = localStorage.getItem('authToken');
  console.log(id);
  const response = await client.mutate({
    mutation: DELETE_ARTICLE_MUTATION,
    variables: {id: parseInt(id) },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.deleteArticle;
};

// Approve Article Service
export const approveArticleService = async (articleId) => {
  const token = localStorage.getItem('authToken');
  console.log(articleId);
  const response = await client.mutate({
    mutation: APPROVE_ARTICLE_MUTATION,
    variables: {articleId: parseInt(articleId),status:"APPROVED" },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.updateArticleStatus;
};

// Reject Article Service
export const rejectArticleService = async (articleId) => {
  const token = localStorage.getItem('authToken');
  console.log(articleId);
  const response = await client.mutate({
    mutation: APPROVE_ARTICLE_MUTATION,
    variables: {articleId: parseInt(articleId),status:"REJECTED" },
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
  return response.data.updateArticleStatus;
};


// Fetch Articles Service
export const fetchApprovedArticlesService = async () => {
  const token = localStorage.getItem('authToken');
  const response = await client.query({
    query: GET_SITE_ARTICLES_QUERY,
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });
  return response.data.listApprovedArticles;
};

// Fetch Articles Service
export const fetchArticlesService = async () => {
  const token = localStorage.getItem('authToken');
  const response = await client.query({
    query: GET_ARTICLES_QUERY,
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });
  return response.data.listArticles;
};

// Fetch Articles Service
export const fetchEditorArticlesService = async () => {
  const token = localStorage.getItem('authToken');
  const response = await client.query({
    query: GET_ARTICLES_QUERY,
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });
  return response.data.listArticles;
};

// Fetch Articles Service
export const fetchPublicArticlesService = async () => {
  const token = localStorage.getItem('authToken');
  const response = await client.query({
    query: GET_PUBLIC_ARTICLES_QUERY,
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });
  return response.data.listPublicArticles;
};
